<template>
  <Modal :value="showDialog" @input="showDialog = $event" max-width="600">
    <div class="d-flex flex-column text-left">
      <Typography variant="h-6">Uploaded Files</Typography>
      <div class="mt-3">
        <div v-if="!attachmentsItem || attachmentsItem.length === 0">No Uploaded Files</div>
        <FormFileList
          v-else
          :attachments-item="attachmentsItem"
          :has-additional-claimants="hasAdditionalClaimants"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
// Components
import Modal from "@/components/generic/Modal.vue";
import Typography from "@/components/generic/Typography.vue";
import FormFileList from "@/components/forms/FormFileList.vue";

export default {
  name: "UploadedFilesDialog",
  components: {
    Modal,
    Typography,
    FormFileList,
  },
  props: {
    show: {
      type: Boolean,
      required: false,
    },
    attachmentsItem: {
      type: Array,
      default: () => [],
    },
    hasAdditionalClaimants: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input"],
  computed: {
    showDialog: {
      get() {
        if (typeof this.show === "boolean") return this.show;
        return false;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {},
};
</script>

<style scoped></style>
